// theme.js

import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#000",
		},
		secondary: {
			main: "#fff",
		},
	},

	typography: {
		fontFamily: "Cairo, sans-serif",

		button: {
			fontSize: 20,
			lineHeight: 1.3,
			textTransform: "none",
		},
		fontSize: 16,
	},

	shape: {
		borderRadius: 8,
	},

	components: {
		MuiButton: {
			styleOverrides: {
				contained: {
					padding: "12px 20px",
				},
			},
		},

		MuiButtonGroup: {
			styleOverrides: {
				contained: {
					"& .MuiButton-contained": {
						backgroundColor: "#b5b5b5",
						color: "rgba(0, 0, 0, 0.3)",

						"&:hover": {
							color: "#fff",
						},
					},
				},
			},
		},

		MuiTabs: {
			styleOverrides: {
				root: {
					minHeight: "inherit",
				},
			},
		},

		MuiTab: {
			styleOverrides: {
				root: {
					fontSize: 15,
					padding: "4px 8px",
					minHeight: "inherit",
					minWidth: "inherit",
				},
			},
		},

		MuiIconButton: {
			styleOverrides: {
				root: {
					borderRadius: 8,

					"&:active": {
						backgroundColor: "#fff",
					},
				},
			},
		},

		MuiTypography: {
			styleOverrides: {
				subtitle2: {
					fontWeight: 400,
				},
			},
		},
	},
});

export default theme;
